export default __webpack_public_path__ + "static/media/cpv_85_education.d85029a3.svg";